import React, {useState, useEffect} from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PropTypes from 'prop-types';
import {toTime, toTimeType, timeConverter, timeOfDayConverter, isObjectEmpty, uploadCSV, replaceAll, timeConverterSM} from '../../../../Utils';
import Spinner from '../../../common/generic/Spinner';
import axios from 'axios';

const ContainerComp = ({pageState, reportState, csvData, setcsvData, loadingLessonCount, setLoadingLessonCount}) =>{
    const [processedMarks, setProcessedMarks] = useState({});
    const [markRecords, setMarkRecords] = useState({});
    const {selectedStudents, selectedProgram} = reportState;
    const [lessonMarks, setLessonMarks] = useState({});
    const [loadingLessonReportCount, setLoadingLessonReportCount] = useState(-1);
    const [fetchingMarks, setFetchingMarks] = useState(false);
    
    /*
    CSV NOTES
    =========
    There is a big problem when trying to upload more then 1 csv file.  The below system will reset all the data in 
    this component and start it over when when the user clicks save.
    
    Steps
    1) User clicks save in either ProgramReportTableComp or AcitivityReportComp
        1b) openCSVPage() will populate csvData using setcsvData({processStage:'newRequest'});
    2) ViewReportsPage checks to see if the marks have changed (* seems to be called way to many times...)
        2b) setReportType(csvData.reportType);
            setSelectedProgram({...csvData.selectedProgram});
            setSelectedStudents([...csvData.selectedStudents]); 
    3) Start the report
        3a) CSV Step 1: checks if a new request for csv and starts to clear the data
        3b) CSV Step 2: clears the data 
        3c) CSV Step 3: keep checking to see when the data has been cleared
        3d) CSV Step 4: once the data for this component has been reset then start the normal start up process for this comp.
        3e) (The normal Startup starts at CSV Step 1) 
    */

    // CSV Step 4: once the data for this component has been reset then start the normal start up process for this comp.
    // The normal Startup starts at CSV Step 1 
    const tryLoadingCSVStage2 = () => {
        if(!csvData) return;
        if(csvData.processStage === 'clearingData'){
            if(isObjectEmpty(lessonMarks) && isObjectEmpty(markRecords) && isObjectEmpty(processedMarks)){
                setcsvData({...csvData, processStage:'clearedData'});
            }
        }
    };
    // CSV Step 3: keep checking to see when the data has been cleared
    useEffect(() =>{tryLoadingCSVStage2();},[lessonMarks]);
    useEffect(() =>{tryLoadingCSVStage2();},[markRecords]);
    useEffect(() =>{tryLoadingCSVStage2();},[processedMarks]);

    // CSV Step 2: clears the data
    useEffect(() => {
        if(!csvData) return;

        if(csvData.processStage === 'clearingData'){
            setLessonMarks({});
            setMarkRecords({});
            setProcessedMarks({});
        }
    },[csvData]);


    const fetchLessonMarks = async (lessonQueries) => {
        //console.log('fetchLessonMarks loadingLessonCount',loadingLessonCount);
           
        if(typeof loadingLessonCount !=='undefined' && loadingLessonCount!==-1) return;
        if(typeof loadingLessonCount ==='undefined' && loadingLessonReportCount!==-1) return;

        let lessonData = [];
        if(typeof loadingLessonCount !=='undefined') setLoadingLessonCount(lessonQueries.length);
        if(typeof loadingLessonCount ==='undefined') setLoadingLessonReportCount(lessonQueries.length);

        //lessonQueries.forEach(lesson=>{
        for(let i=0; i< lessonQueries.length; i++){
            if(typeof loadingLessonCount !=='undefined') setLoadingLessonCount(lessonQueries.length-i);
            if(typeof loadingLessonCount ==='undefined') setLoadingLessonReportCount(lessonQueries.length-i);
            try{ // skip anything with an Internal Server Error
                let response = await axios.post(reportState.V7DATABASE.api,lessonQueries[i]);    
                lessonData.push(response.data.body);
            }catch(err){console.error('Internal Server Error',err);}
        }

        if(typeof loadingLessonCount !=='undefined') setLoadingLessonCount(-1);
        if(typeof loadingLessonCount ==='undefined') setLoadingLessonReportCount(-1);
        // console.log('lessonData',lessonData);

        let reportData = JSON.parse(localStorage.getItem('reportData'));
        let masterLevel = parseInt(reportData.masterLevel)/100;

        let lessonFormated = {};
        lessonData.forEach(lessonRecs=>{
            lessonRecs.forEach(lessonRec=>{
                let studentID = lessonRec['StudentID'];// lessonRec['StudentKey'].split('#')[0];
                if(!(studentID in lessonFormated)) lessonFormated[studentID]=[];
                let score = Number(lessonRec.QuestionsRight)/Number(lessonRec.QuestionsAttempted);
                let wasMastered = score >= masterLevel;
                lessonRec.TimesCompleted=(lessonRec.CompletedDate!=='0')?'1':'Incomplete';
                lessonRec.TimesMastered=(lessonRec.CompletedDate!=='0' && wasMastered)?'1':'0';
                lessonFormated[studentID].push(lessonRec);
            });
        });
        // console.log('lessonFormated',lessonFormated);

        setLessonMarks({data:lessonFormated});
    };

    // CSV Step 1: checks if a new request for csv and starts to clear the data 
    // Normal Startup Step 1:
    useEffect(() => {
        if(fetchingMarks) return;

        if(csvData){
            if(csvData.processStage==='newRequest'){
                // csvData.setloadingCSV({...csvData.loadingCSV, activity:true});
                setcsvData({...csvData, processStage:'clearingData'});
                return;
            }

            if(csvData.processStage==='clearingData') return;
        }

        if(isObjectEmpty(lessonMarks)){
            let reportData = JSON.parse(localStorage.getItem('reportData'));  
            let lessonQueries = selectedStudents.map(studentRec=>{
                const DynamoDB = {
                    Query:{Header:'LessonMarkQuery', Run:'queryMarkByStudentID'},
                    CustID: sessionStorage.getItem('custID'),
                    Criteria:{
                        ClassPart: `${reportData.classID}#LessonMark`,
                        StudentKey:`${studentRec.id}#${selectedProgram.id}`
                    }
                };
    
                const MySQLDB = {
                    Query:{Header:'LessonMarkQuery', Run:'queryMarkByStudentID'},
                    CustID: sessionStorage.getItem('custID'),
                    Criteria:{
                        id: `${studentRec.id}#${selectedProgram.id}`
                    }
                };
    
                const AuroraDB = MySQLDB;
                const map = {DynamoDB, MySQLDB, AuroraDB};
                return {
                    Security: {
                        tag:reportData.token,
                        userID: sessionStorage.getItem('userID'),
                        ignoreSignon: true
                    },
                    [reportState.V7DATABASE.type]: map[reportState.V7DATABASE.type]       
                };
            });
            setFetchingMarks(true); // stop if from fetching marks forever if something messes up
            fetchLessonMarks(lessonQueries);
        }
    });

    useEffect(() => {
        if(csvData && csvData.processStage !== 'clearedData') return; // don't setup markRecords for csv files without being ready 
        if(isObjectEmpty(lessonMarks)) return;
        
        let marks = {};
        let key = 'unavailable';
        let studMarks = {};
        Object.keys(lessonMarks.data).forEach(key => {        
            marks = {
                isloaded: true,
                data: {[key]: lessonMarks.data[key]}
            }; 
            studMarks[key]=marks;
        });
        setMarkRecords(studMarks);
    }, [lessonMarks]);     

    useEffect(() =>{tryLoadingNow();},[markRecords]);
    const tryLoadingNow = () => {
        if(isObjectEmpty(lessonMarks)) return; // do we have the raw marks?
        if(isObjectEmpty(markRecords)) return; // do we have the raw marks converted to markRecords?
        if(!isObjectEmpty(processedMarks)) return; // We are trying to build the ProcessedMarks here        

        let reportData = JSON.parse(localStorage.getItem('reportData'));
        let masterLevel = parseInt(reportData.masterLevel)/100;

        // console.log('selectedStudents',selectedStudents,markRecords);
        let studentsLessonMarks = selectedStudents.reduce((acc,studentRec)=>{
            let studentID = studentRec.id;
            let studentMarkRecords = markRecords[studentID];            
            if(!studentMarkRecords) return acc; // still loading marks            
            acc[`${studentRec.id}+${studentRec.name}`] = studentMarkRecords.data[`${studentID}`];
            return acc;
        },{});

        Object.keys(studentsLessonMarks).forEach(key=>{
            let lessons = [];
            studentsLessonMarks[key].forEach((lesson, i)=>{
                // TODO don't quary course quizzes with course lessons because its too much to read from the database
                if(studentsLessonMarks[key][i].DetailJSON.length>0){
                    let isQuizAnswers = Object.keys(studentsLessonMarks[key][i].DetailJSON[0]).includes('data');
                    if(!isQuizAnswers)
                        lessons.push(studentsLessonMarks[key][i].DetailJSON);
                }
            });            
            
            lessons = lessons.map((lesson) => lesson.sort((a,b) => (a.CreationDate - b.CreationDate)));
            studentsLessonMarks[key]=lessons; 
        });

        // console.log('studentsLessonMarks',studentsLessonMarks);
        setProcessedMarks(studentsLessonMarks);

        if(csvData){
            let newLine = '%0A';
            let csvString = '';
            // csvString =`"* Each teacher can set their own mastery level for the class and an activity is considered to be mastered when the student answers at least that ${masterLevel*100}% of the questions correctly on any attempt"${newLine}`;
            // csvString +=`"Student without marks will not appear in this report"${newLine}`;

            let name = '';
            if(Object.keys(studentsLessonMarks).length===1){
                name = Object.keys(studentsLessonMarks)[0].split('+')[1]+'_';
            }
    
            const showDate=(theDate)=> timeConverter(parseInt(theDate));
            const showTime=(duration)=>`${toTime(duration)} ${toTimeType(duration)}`;
            
            Object.keys(studentsLessonMarks).forEach(markKey => {
                let lessons = studentsLessonMarks[markKey];
                let currentName = markKey.split('+')[1];         
                
                csvString += `"${currentName}"${newLine}`;
                csvString += '"Date","Lesson","Number of Questions","Number of Correct","Time","Standard"'+newLine;

                //console.log('lessons',lessons);
                lessons.forEach(course=>{
                    course.forEach(lesson=>{
                        const {CreationDate, Name, QuestionsAttempted, QuestionsRight, Time,Standard} = lesson;
                        csvString += `"${showDate(CreationDate)}","${Name}","${QuestionsAttempted}","${QuestionsRight}","${showTime(Time)}","${Standard}"${newLine}`;
                    });
                });
                csvString +=`${newLine}`;
            });

            let today = new Date();
            today = timeConverterSM(today.getTime());
            uploadCSV(name+'CourseReport_'+selectedProgram.name+'_'+today,csvString);
            csvData.setloadingCSV({...csvData.loadingCSV, lessonMarks:false});
        }

    };     
    
    const HeaderComp=({header}) => <center>
        <h4><Row>
            <Col xs='4'>{header.student}</Col> 
            <Col xs='4'>{header.program} </Col>
            <Col xs='4'>Mark Report</Col>
        </Row></h4>
    </center>;

    if(csvData) return <></>;    
    if(isObjectEmpty(lessonMarks)) return <> <Spinner/> <center>Loading...({loadingLessonReportCount}) </center> </>;
    return <>
        {Object.keys(processedMarks).length < selectedStudents.length && <center> <p>  Students without marks will not appear in this report </p></center>}
        {Object.keys(processedMarks).map((key, i) => (
            <span key={i}><br/> 
                <HeaderComp header={{student: key.split('+')[1], program: selectedProgram.name}}/>
                {Object.keys(processedMarks[key]).map((lessonData, ii) => (
                    <span key={ii}><br/> 
                        <LessonBuilderCourseReportComp header={{LastAccessedDate:processedMarks[key][ii][0].LastAccessedDate, CompletedDate:processedMarks[key][ii][0].CompletedDate}} tableData={processedMarks[key][ii]}/>
                    <br/></span>
                ))}                
            <br/></span>
        ))}
    </>;
};

const LessonBuilderCourseReportComp = ({header, tableData}) => {
    const [masterLevel, setMasterLevel] = useState(0.8);

    useEffect(()=>{
        let reportData = JSON.parse(localStorage.getItem('reportData'));
        if(masterLevel !== (parseInt(reportData.masterLevel)/100))
            setMasterLevel(parseInt(reportData.masterLevel)/100);
    });

    const showDate=(theDate)=>{        
        if(theDate!=='0')
            return timeConverter(parseInt(theDate));
        return '(Incomplete)';
    };

    const titleRow = <Row style={{ fontSize:'0.9em', fontWeight:'bold'}}>
        <Col style={{textAlign: 'center'}} xs='2'>Date</Col>
        <Col style={{textAlign: 'center'}} xs='3'>Lesson</Col>
        <Col style={{textAlign: 'center'}} xs='1'># of Questions</Col>
        <Col style={{textAlign: 'center'}} xs='1'># of Correct</Col>
        <Col style={{textAlign: 'center'}} xs='1'>Time</Col>
        <Col style={{textAlign: 'center'}} xs='3'>Standard</Col>
    </Row>;    

    return (
        <>
            {titleRow}
            <hr/>
            {tableData.map((markRec, mark_i) => <TableRow key={mark_i} data={markRec} fontWeight={'normal'}/> )}
        </>
    );
};

LessonBuilderCourseReportComp.propTypes = {
    tableData: PropTypes.array
};

const TableRow = (props) => {

    const { CreationDate, Name, QuestionsAttempted, QuestionsRight, Standard, Time} = props.data;
       
    const showDate=(theDate)=>{        
        if(theDate!=0)
            return timeOfDayConverter(parseInt(theDate));
        return '--';
    };

    const showTime=(duration)=>{
        return `${toTime(duration)} ${toTimeType(duration)}`;
    };

    return (
    <>
        <Row style={{fontSize:'0.9em'}}>
            <Col style={{textAlign: 'center', fontWeight: props.fontWeight}} xs='2'>{showDate(CreationDate)}</Col>
            <Col style={{textAlign: 'center', fontWeight: props.fontWeight}} xs='3'>{Name}</Col>
            <Col style={{textAlign: 'center', fontWeight: props.fontWeight}} xs='1'>{QuestionsAttempted}</Col>
            <Col style={{textAlign: 'center', fontWeight: props.fontWeight}} xs='1'>{QuestionsRight}</Col>
            <Col style={{textAlign: 'center', fontWeight: props.fontWeight}} xs='1'>{showTime(Time)}</Col>
            <Col style={{textAlign: 'center', fontWeight: props.fontWeight}} xs='3'>{Standard}</Col>
        </Row>
    </>
    );
};

TableRow.propTypes = {
    fontWeight: PropTypes.string,
    data: PropTypes.object
};
export default ContainerComp;